import o from "./highrise970.mjs";
function t() {
  return o;
}
const e = {
  self: t
};
export {
  e as default
};
